module.exports = __webpack_public_path__ + "static/media/duplicate-icon.b714a7b8.svg";